import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, getHotArticles, getFeaturedArticles, getDailyArticles, articles } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const hotArticles = getHotArticles();
  const featuredArticles = getFeaturedArticles();
  const dailyArticles = getDailyArticles();
  const recentArticles = articles.slice(0, 8);

  return (
    <>
      <SchemaOrg type="WebSite" data={{
        name: siteInfo.name,
        url: 'https://51chigua.com',
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://51chigua.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="Organization" data={{
        name: siteInfo.name,
        url: 'https://51chigua.com',
        description: siteInfo.description,
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero */}
          <section className="relative pt-16">
            <div className="relative h-[420px] md:h-[560px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20social%20media%20entertainment%20news%20abstract%20background%20with%20warm%20red%20and%20gold%20gradient%20tones%2C%20modern%20minimalist%20digital%20design%2C%20flowing%20organic%20shapes%2C%20soft%20atmospheric%20lighting%2C%20editorial%20style%20with%20elegant%20composition%2C%20subtle%20geometric%20patterns%2C%20luxurious%20feel&width=1600&height=800&seq=home-hero-bg&orientation=landscape"
                alt="51吃瓜官网"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
              <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6">
                <div className="text-center w-full max-w-3xl">
                  <h1 className="font-heading text-2xl md:text-5xl text-background-50 mb-4 leading-tight">
                    {siteInfo.name}
                  </h1>
                  <p className="text-sm md:text-lg text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
                    {siteInfo.tagline}
                  </p>
                  <div className="flex flex-wrap items-center justify-center gap-3">
                    {categories.slice(0, 4).map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="px-5 py-2.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-100 text-sm font-medium border border-background-50/20 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Hot Articles */}
          <section className="px-4 md:px-6 py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </span>
                <h2 className="font-heading text-2xl text-foreground-900">热门吃瓜</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {hotArticles.slice(0, 2).map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </div>
          </section>

          {/* Daily Featured */}
          <section className="px-4 md:px-6 py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-calendar-check-line text-background-50 text-lg"></i>
                </span>
                <h2 className="font-heading text-2xl text-foreground-900">每日精选</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {dailyArticles.slice(0, 6).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="px-4 md:px-6 py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
                  <i className="ri-apps-2-line text-background-50 text-lg"></i>
                </span>
                <h2 className="font-heading text-2xl text-foreground-900">内容分类</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all cursor-pointer"
                  >
                    <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all flex-shrink-0">
                      <i className={`${cat.icon} text-xl`}></i>
                    </span>
                    <div className="min-w-0">
                      <h3 className="font-heading text-base text-foreground-900 mb-1">{cat.name}</h3>
                      <p className="text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured */}
          <section className="px-4 md:px-6 py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-star-line text-background-50 text-lg"></i>
                </span>
                <h2 className="font-heading text-2xl text-foreground-900">精选推荐</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="px-4 md:px-6 py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
                    <i className="ri-time-line text-background-50 text-lg"></i>
                  </span>
                  <h2 className="font-heading text-2xl text-foreground-900">最新吃瓜</h2>
                </div>
                <Link
                  to="/category/yule-bagua"
                  className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
                >
                  查看更多 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {recentArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="px-4 md:px-6 py-14 bg-accent-500">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">
                加入吃瓜群众的行列
              </h2>
              <p className="text-background-200 mb-8 text-sm md:text-base">
                每日更新最新吃瓜资源，不错过任何一个热点
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                {categories.slice(0, 2).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-6 py-3 rounded-lg bg-background-50 text-accent-600 font-medium text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
                  >
                    浏览{cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}